import { Wrapper } from './Info.styles';
import { InfoActions } from './InfoActions';
import { InfoContent } from './InfoContent';

import { useCourseStats } from '@/store';

export const Info = () => {
  const { courseStats } = useCourseStats();

  if (!courseStats) return null;

  return (
    <Wrapper>
      <InfoContent />
      <InfoActions course={courseStats.course} />
    </Wrapper>
  );
};
